module.exports = "\n<div class=\"row center-block\">\n  <div class=\"col-md-12\">\n    <img src=\"assets/img/no-results.png\" class=\"img-fluid\" alt=\"\">\n  </div>\n  <div class=\"col-md-12 mt-4\">\n    <h5>{{ message }}</h5>\n  </div>\n  <ng-content></ng-content>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/empty/empty.component.html
// module id = ./src/app/shared/empty/empty.component.html
// module chunks = main